import httpClient from "./httpClient";

export async function buscarDashboardGestaoComercial({
  responsavelIds = [],
  supervisorId = [],
  dataInicio,
  dataFim,
  bancosIds = [],
  conveniosIds = [],
  tiposConvenio = [],
  granularidadeEvolucao,
  tipoPeriodo,
  secoes,
} = {}) {
  const response = await httpClient.post("/api/dashboard/gestao-comercial", {
    responsavelIds: Array.isArray(responsavelIds) ? responsavelIds : [],
    supervisorId: Array.isArray(supervisorId) ? supervisorId : [],
    dataInicio,
    dataFim,
    bancosIds: Array.isArray(bancosIds) ? bancosIds : [],
    conveniosIds: Array.isArray(conveniosIds) ? conveniosIds : [],
    tiposConvenio: Array.isArray(tiposConvenio) ? tiposConvenio : [],
    granularidadeEvolucao: granularidadeEvolucao || undefined,
    rankingParceiro: "PRODUCAO",
    tipoPeriodo: tipoPeriodo || "APROVACAO",
    // Blocos pedidos (PRODUCAO, TAREFAS). Omitido = resposta inteira, como era antes do campo
    // existir: o servidor calcula só o que vier aqui.
    secoes: Array.isArray(secoes) && secoes.length ? secoes : undefined,
  });
  return response.data || {};
}

export async function buscarProducaoParceiros({
  responsavelIds = [],
  supervisorId = [],
  dataInicio,
  dataFim,
  bancosIds = [],
  conveniosIds = [],
  tiposConvenio = [],
  tipoPeriodo = "APROVACAO",
} = {}) {
  const response = await httpClient.post("/api/dashboard/producao-parceiros", {
    responsavelIds: Array.isArray(responsavelIds) ? responsavelIds : [],
    supervisorId: Array.isArray(supervisorId) ? supervisorId : [],
    dataInicio,
    dataFim,
    bancosIds: Array.isArray(bancosIds) ? bancosIds : [],
    conveniosIds: Array.isArray(conveniosIds) ? conveniosIds : [],
    tiposConvenio: Array.isArray(tiposConvenio) ? tiposConvenio : [],
    granularidadeEvolucao: "DIA",
    rankingParceiro: "PRODUCAO",
    tipoPeriodo,
  });
  return response.data || { escopo: {}, parceiros: [] };
}
